import React from "react";
import YellowDivider from "../dividers/YellowDivider";
import "../../stylesheet/components/sections/SectionComingSoon.scss";

const SectionComingSoon: React.FC<{ title: string; body: string }> = ({
  title,
  body,
}) => {
  return (
    <div className="preview-outer">
      <div className="preview-summary">
        <div className="preview-title">
          <h2>{title}</h2>
          <YellowDivider heading="h2" />
        </div>
        <p className="p2">{body}</p>
      </div>
      <div className="coming-soon-block"></div>
    </div>
  );
};

export default SectionComingSoon;
